import React, { useState, useEffect, useRef } from "react";
import { FaTrash, FaUserCircle } from "react-icons/fa";
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';

import "../../Dasbord.css"
import "./Project.css";

import { Api } from "../../../services/api";

import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import { CommonService } from "../../../services/commonService";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { BsFillInfoCircleFill } from "react-icons/bs";


import useWindowSize from "../../useWindowSize";
import { BiCheck, BiPlusMedical } from "react-icons/bi";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";

const Project = () => {

  const [listOfYear, setListOfYear] = useState([]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectTitle, setprojectTitle] = useState("Add New Project");

  // --------------------------------list modal--------------------------------------------------------
  const [selectedProject, setSelectedProject] = useState(null);
  const [editProject, setEditProject] = useState(CommonService.getProjectBlankData());
  const [relatedProject, setRelatedProject] = useState(null);


  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [projectCostPer, setProjectCostPer] = useState();
  const [backgroundColorForProjectType, setBackgroundColorForProjectType] = useState('FFBF04');

  // ------------------------Highlight the list-----------------------------------

  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);

  const [projects, setProjects] = useState([]);

  const [projectsType, setProjectsType] = useState([]);
  const [projectsManager, setProjectsManager] = useState([]);


  // ----------- new Added 17-04-2024 -----------
  const [developmentManager, setDevelopmentManager] = useState();
  const [developmentManagerList, setDevelopmentManagerList] = useState([]);
  const [preConManager, setPreConManager] = useState();
  const [preConManagerList, setPreConManagerList] = useState([]);
  const [interiorDesign, setInteriorDesign] = useState();
  const [interiorDesignList, setInteriorDesignList] = useState([]);
  const [jobAutospy, setJobAutospy] = useState();
  const [jobAutospyList, setJobAutospyList] = useState([]);
  const [warranty, setWarranty] = useState();
  const [warrantyList, setWarrantyList] = useState([]);
  // ------------------------------------------------

  const [projectDelete, setProjectDelete] = useState('project'); 
  const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to permanently delete this project?'); 
  const [selectedProduct, setSelectedProduct] = useState(null);
  const toast = useRef(null);

  //------------------------Project  Name--------------------------------------------------------------
  const [projectId, setProjectId] = useState("");
  const [projectTypeName, setProjectTypeName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [contactDate, setContactDate] = useState("");
  const [FSADate, setFSADate] = useState("");
  const [contractDate, setContractDate] = useState("");

  const [preConEstimatedCompleteDate, setPreConEstimatedCompleteDate] = useState("");
  const [actualStartDate, setActualStartDate] = useState("");
  const [actualCompletionDate, setActualCompletionDate] = useState("");
  const [hoursPerDay, setHoursPerDay] = useState("");
  const [pM, setPM] = useState("");
  const [projectStatus, setProjectStatus] = useState("Opportunity");
  const [projectCostPerForProject, setProjectCostPerForProject] = useState("");
  const [projectFixedMonth, setProjectFixedMonth] = useState("");
  const [projectFixedPrice, setProjectFixedPrice] = useState("");
  const [projectEsitmatedSales, setProjectEsitmatedSales] = useState("");
  const [projectActualToDate, setProjectActualToDate] = useState("");
  const [projectActualFees, setProjectActualFees] = useState("");

  const [contract_amount, setContract_amount] = useState("");

  const [internalJob, setInternalJob] = useState("");


  // ---------------------------------------------------------------------------------------------

  const [projectOrigExpectedGP, setProjectOrigExpectedGP] = useState("");
  const [type, setType] = useState("Add");
  const [activeIndex, setActiveIndex] = useState(0);
  //------------------------Project  Contarct--------------------------------------------------------------



  const [isAddManualModalOpen, setIsAddManualModalOpen] = useState(false);


  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // ---------------------------------------------------------------------------------------------
  const size = useWindowSize();
  const [rows, setRows] = useState(14);

  useEffect(() => {
    if (size.width < 600) {
      setRows(5); // Set rows to 5 for small screens
    } else if (size.width < 1200) {
      setRows(8); // Set rows to 10 for medium screens
    } else {
      setRows(12); // Set rows to 14 for large screens
    }
  }, [size.width]);
  // ---------------------------------------------------------------------------------------------
  const [deleteContract, setDeleteContract] = useState('Delete');

  const [isShow, setIsShow] = useState(false);


  const formik = useFormik({
    initialValues: {
      projectId: '',
      actualStartDatePM: '',
      forecastedCompletionDatePM: '',
      actualCompletionDatePM: '',
     


    },
    validate: (data) => {
      let errors = {};



    },

    onSubmit: (data) => {
      console.log(data);
      const token = localStorage.getItem('authToken');
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        "Content-Type": "application/json",
      };
    

      var url = Api.API_BASE_URL + 'manual-project-playbooks-save';


      fetch(url, {
        method: "POST",
        headers: {
          headers
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            setIsAddManualModalOpen(false);
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

            getProjectType();
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });

      console.log(data);
    }
  });

  var ProjectStatusList = ['ACTIVE', 'WARRANTY', 'ARCHIVE', 'HOLD', 'CANCELLED', 'COMPLETED'];
  useEffect(() => {
    console.log('Fetching projects...');
    // Fetch the list of projects from the API
    getProjectType();
    getProject('ALL');

    console.log('Fetching projects...', activeIndex);

    getyear();
    initFilters();
  }, []);

  //** 05-03-2024 start */
  const [filters, setFilters] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      first_name: { value: null, matchMode: FilterMatchMode.IN },
      last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
     
    });
    setGlobalFilterValue('');
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  //** 05-03-2024 end  */
  const getyear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const initialYear = year - 5;
    const expectedYear = year + 10;
    var arr = [];
    for (let i = initialYear; i < expectedYear; i++) {
      arr.push(i);
    }
    setListOfYear(arr);
  }


  const getProjectType = async () => {
    const token = localStorage.getItem('authToken');
    const headers = {
      'Authorization': token ? `Bearer ${token}` : '',
      "Content-Type": "application/json",
    };
  


    axios.get(Api.API_BASE_URL + 'get-all-active-project-type',{headers})
      .then((response) => {

        setProjectsType(response.data.result)
        if (response.data.result.length > 0) {
          setBackgroundColorForProjectType(response.data.result[0].color_code);
        }
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
    axios.get(Api.API_BASE_URL + 'get-all-active-project-manager',{headers})
      .then((response) => {

        
        setProjectsManager(response.data.allUsers)
        setDevelopmentManagerList(response.data.allUsers)
        setPreConManagerList(response.data.allUsers)
        setInteriorDesignList(response.data.allUsers)
        setJobAutospyList(response.data.allUsers)
        setWarrantyList(response.data.allUsers)

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }

  const getProject = async (projectStatus) => {

    console.log('Fetching projects...projectStatus ', projectStatus);

    const role_id = localStorage.getItem('role_id');
    console.log("---gg", role_id);

    const token = localStorage.getItem('authToken');
  const headers = {
    'Authorization': token ? `Bearer ${token}` : ''
  };


    var url = Api.API_BASE_URL + 'get-all-project-by-status/' + projectStatus + '/' + role_id;


    axios.get(url,{headers})
      .then((response) => {
        setIsLoading(false);
        setProjects(response.data.result);
        setIsShow(response.data.isShow);
        // setSearchprojectsProjects(response.data.result);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error fetching projects:', error);
      });



  }

  const [projectIdToDelete, setProjectIdToDelete] = useState(null);

  const openModal = () => {

    setprojectTitle("Add New Project");
    setType("Add");
    if (projectsType.length > 0) {
      setBackgroundColorForProjectType(projectsType[0].color_code);
    }
    setEditProject(CommonService.getProjectBlankData());
    setProjectId("");
    setProjectName("");
    setProjectEsitmatedSales("");
    setInternalJob("");
    setContractDate("");
    setPreConEstimatedCompleteDate("");
    setHoursPerDay("");
    setProjectStatus("Opportunity");
    setContract_amount("");
    setProjectActualToDate("");
    setProjectFixedMonth("");
    setProjectTypeName("");
    setContactDate("");
    setFSADate("");
    setActualStartDate("");
    setActualCompletionDate("");
    setProjectOrigExpectedGP("");
    setProjectCostPerForProject("");
    setProjectActualFees("");
    setProjectFixedPrice("");
    setPM("");
    setPreConManager("");
    setDevelopmentManager("");
    setInteriorDesign("");
    setJobAutospy("");
    setWarranty("");
    setIsModalOpen(true);
  }

  const openEditModal = (project) => {
    setprojectTitle("Edit Project");
    console.log("project",project);
    setBackgroundColorForProjectType(project.projectTypeColorCode);
    setType("Edit");
    setProjectId(project.id);
    setEditProject(project);
    setProjectName(project.project_name)
    setProjectEsitmatedSales(project.esitmatedSales)
    setInternalJob(project.internal_job)
    setContractDate(project.contract_date)
    setPreConEstimatedCompleteDate(project.forecasted_complation_data_pm)
    setHoursPerDay(project.hours_per_day)
    setProjectStatus(project.project_status)
   
    setContract_amount(project.contract_amount)
    setProjectActualToDate(project.actual_to_date)
    setProjectFixedMonth(project.fixed_month)
    setProjectTypeName(project.project_type)
    setContactDate(project.contact_date)
    setFSADate(project.fsa_date)
    setActualStartDate(project.actual_start_date_pm)
    setActualCompletionDate(project.actual_complation_date_pm)
    setProjectOrigExpectedGP(project.orig_expected_gp)
    setProjectCostPerForProject(project.project_cost_per)
    setProjectActualFees(project.actual_fees)
    setProjectFixedPrice(project.fixed_price)
    setPM(project.project_manager)
    setPreConManager(project.pre_con_manager);
    setDevelopmentManager(project.development_manager);
    setInteriorDesign(project.interior_design);
    setJobAutospy(project.job_autospy);
    setWarranty(project.warranty);

    console.log("projectStatus",projectStatus);

    setIsModalOpen(true);
  };

  const closeModal = () => {

    setIsModalOpen(false);
    setIsDeleteConfirmationModalOpen(false);
    setIsAddModalOpen(false);
    setIsDetailsModalOpen(false);
    setSelectedProduct(null);

  };

  const handleAddProject = async (event) => {
    event.preventDefault();

    try {
      const requestData = {
        projectName: event.target.projectName.value,
        projectType: event.target.projectType.value,
        
        hoursPerDay: event.target.hoursPerDay.value,
        pM: event.target.pM.value,
        status: event.target.projectStatus.value,
       
        orig_expected_gp: projectOrigExpectedGP,
        project_cost_per: projectCostPerForProject,
        fixed_month: event.target.fixed_month.value,
        fixed_price: projectFixedPrice,
       
        internal_job: internalJob,
        actual_fees: projectActualFees,
        actual_to_date: projectActualToDate,
        contract_amount: contract_amount,
        pre_con_manager: event.target.pre_con_manager.value,
        interior_design: event.target.interior_design.value,
        job_autospy: event.target.job_autospy.value,
        warranty: event.target.warranty.value,
        development_manager: event.target.development_manager.value,
      };
      console.log(requestData);

      const token = localStorage.getItem('authToken');
      const headers = {
        'Authorization': token ? `Bearer ${token}` : '',
        "Content-Type": "application/json",
      };
    

      var url = Api.API_BASE_URL + 'project-add';
      if (type == "Edit") {
        url = Api.API_BASE_URL + 'project-update/' + projectId;
      }

      fetch(url, {
        method: "POST",
        headers:headers,
       
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((result) => {

          if (result.error !== '') {
            toast.current.show({ severity: 'error', detail: result.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: result.result });
            closeModal();

           
            getProject('ALL');
          }

          console.log(result);
        })
        .catch((error) => {
          console.error("Error:", error);
        });


    } catch (error) {

      console.error('Error adding project:', error);
    }

  };

  //-----------------------------------------------------------------------------------------

  const handleDeleteProject = (projectId,) => {
    setDeleteContract('Archive');

    setProjectDelete('project');
    setProjectDeleteTitle('Are you sure you want to permanently delete this project?');
    setProjectIdToDelete(projectId);
    setIsDeleteConfirmationModalOpen(true);
  };

  const token = localStorage.getItem('authToken');
  const headers = {
    'Authorization': token ? `Bearer ${token}` : '',
    "Content-Type": "application/json",
  };


  const confirmDelete = async () => {
    var baseUrl = Api.API_BASE_URL + 'delete-project/' + projectIdToDelete

    if (projectDelete != 'project') {
      baseUrl = Api.API_BASE_URL + 'delete-project-contract/' + projectIdToDelete
    }
    axios.get(baseUrl,{headers})
      .then((response) => {
        toast.current.show({ severity: 'success', detail: response.result, life: 3000 });
       
        getProject('ALL');
        closeModal();
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }


  // -----------------------------------------------------------------------------

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <div>
          {isShow &&
            (<FaTrash title="Delete the Project" onClick={() => handleDeleteProject(rowData.id)} style={{ color: 'darkred' }} />)
          }
        </div>
      </React.Fragment>
    );
  };





  const priceBodyTemplate = (rowData) => {
    if (rowData === '') {
      return '';
    }
    if (rowData === null) {
      return '';
    }
    if (typeof rowData === 'string') {
      rowData = parseFloat(rowData, 10);
    }

    const isNegative = rowData < 0;  // Check if the value is negative
    const absoluteValue = Math.abs(rowData);

    return (
      <span style={{ color: isNegative ? "red" : "black", }}>
        {formatCurrency(rowData)}

      </span>
    );
  };



  const priceBodyTemplateForProjectedCosetFees = (rowData, contractAmount) => {
    if (rowData === '') {
      return '';
    }
    if (rowData === null) {
      return '';
    }
    if (typeof rowData === 'string') {
      rowData = parseFloat(rowData, 10);
    }

    const isNegative = rowData < 0;  
    const absoluteValue = Math.abs(rowData);

    var value = contractAmount * (rowData / 100);

    return (
      <span style={{ color: isNegative ? "red" : "black" }}>
        {formatCurrency(value)}

      </span>
    );
  };

  const priceBodyTemplatee = (rowData) => {
    if (rowData === '') {
      return '';
    }
    let numberValue = Number(rowData);
   
    if (isNaN(numberValue)) {
      console.error("rowData is not a number");
      return '';
    }

   
    const isNegative = rowData < 0; 

    return (
      <span style={{ color: isNegative ? "red" : "black" }}>
        
        {numberValue.toFixed(0) + '%'}
      </span>
    );
  };

  const formatCurrency = (value) => {

    if (isNaN(value)) {
      console.error("rowData is not a number");
      return '';
    }
   


    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };


  const header = (
    <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
      <h4 className="">Manage Project</h4>

      <div>
        <span className="p-input-icon-left" >
          <InputText className="input-field" type="search" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..." style={{ margin: '0px' }} />
        </span>

        <button type="button" title='Add a new project' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
          <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
            <BiPlusMedical size={14} />
            <span> ADD </span>
          </div>
        </button>

      </div>
    </div>
  );

  const getProjectTypeNameAndIcon = (projectType, projectTypeColorCode) => {
    return <span><i className="pi pi-circle-fill" style={{ color: "#" + projectTypeColorCode }}> </i> {projectType}</span>
  }

  const getPMNameAndIcon = (projectType, projectTypeColorCode) => {
    return <span><FaUserCircle style={{ color: "#" + projectTypeColorCode }} /> {projectType}</span>
  }

  const showDate = (date) => {
    if (date === '0000-00-00') {
      return '';
      
    }
    if(date==null){
      return date;
    }
    const timestamp = new Date(date);



    if (!isNaN(timestamp.getTime())) {
      return timestamp.toISOString().split('T')[0];
  }
  
    return date;
  }

  const showDevide = (date) => {

    if (date == '') {
      return '0/0';
    }
    if (date == null) {
      return '0/0';
    }
    return date;
  }


  const inputBackgroundColor = projectStatus === 'Opportunity' ? '#00AC47' : projectStatus === 'Lead' ? '#0b2ca1' : projectStatus === 'Lead Lost' ? '#fc1b5f' : projectStatus === 'Lead Hold' ? '#740001' : projectStatus === 'Lead Tuned Down' ? '#bc0571' : projectStatus === 'FSA Active' ? '#8728e2': projectStatus === 'FSA Hold' ? '#ef24bb': projectStatus === 'FSA Cancelled' ? '#59260b': projectStatus === 'Contract Active' ? '#0a673d': projectStatus === 'Contract Hold' ? '#ef24bb' :  projectStatus === 'Contract Cancelled' ? '#bc0571':  projectStatus === 'Warranty' ? '#fbac66':  projectStatus === 'Complete' ? '#74c365' : 'transparent';

  const onProjectTypeOnChange = (e) => {
    setProjectTypeName(e.target.value)

    const projectTypeData = projectsType.find((val) => val.id === e.target.value);
    console.log(projectTypeData);
    setBackgroundColorForProjectType(projectTypeData.color_code);
  }


  const handleSelectionChange = (product) => {
    setSelectedProduct(product);
    openEditModal(product);
  };

  // --------------------------
  const [selectedColumnField, setSelectedColumnField] = useState(null);
  const statusItemTemplate = (option) => {
    const displayStatus = option === 'ARCHIVE' ? 'COMPLETE' : option;
    const color = getSeverity(displayStatus);
    return <Tag value={displayStatus} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;
  };
  const getSeverity = (status) => {

    switch (status) {

      

      case 'Opportunity':
        return '#00AC47'; 

      case 'Lead':
        return '#0b2ca1';

      case 'Lead Lost':
        return '#fc1b5f';

      case 'Lead Hold':
        return '#740001';

      case 'Lead Tuned Down':
        return '#bc0571';

      case 'FSA Active':
        return '#8728e2';
      case 'FSA Hold':
        return '#ef24bb';
      case 'FSA Cancelled':
        return '#59260b';

      case 'Contract Active':
        return '#0a673d';
      case 'Contract Hold':
        return '#ef24bb';
      case 'Contract Cancelled':
        return '#bc0571';

      case 'Warranty':
        return '#fbac66';
      case 'Complete':
        return '#74c365';

      default:
        return '#00AC47';
    }
  };

  const projectStatusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={selectedColumnField} options={options} onChange={(e) => {

        console.log(e.value)
        if (e.value == undefined) {
          setSelectedColumnField(null)
          getProject('ALL');
        } else {
          setSelectedColumnField(e.value)
          getProject(e.value);
        }


      }
      } itemTemplate={statusItemTemplate} placeholder="Select One" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
    );
  };
  // --------------------------

  const DataTableTabView = (bgColor) => {
    return (<div className="fontSize m-0 " style={{ width: "100%" }} >
      <div className="pagination-datable-height">
        <DataTable
          value={projects}
          paginator
          rows={rows}
          // rows={12}
          filterDisplay="row"
          dataKey="id"
          scrollHeight="flex"
          selection={selectedProduct}
          onSelectionChange={(e) => setSelectedProduct(e.value)}
          selectionMode="single"
          header={header}
          tableStyle={{ minWidth: "50rem", cursor: "pointer", overflow: "auto", borderCollapse: 'separate', borderSpacing: '0' }}
          filters={filters}
          globalFilterFields={['project_name', 'project_type', 'first_name', 'last_name',]}
        >
          <Column body={actionBodyTemplate} header="Action" frozen exportable={false} style={{ minWidth: '24px', position: 'sticky', textAlign: 'center', padding: '2px', backgroundColor: '#F8F9FA', paddingRight: '10px' }}></Column>

          <Column field="project_status" header="Project Status" body={(e) => statusItemTemplate(e.project_status)} frozen style={{ minWidth: '8rem', position: 'sticky', backgroundColor: '#F8F9FA', textAlign: 'center' }} filter filterElement={() => projectStatusRowFilterTemplate(['Opportunity','Lead', 'Lead Lost', 'Lead Hold', 'Lead Tuned Down', 'FSA Active', 'FSA Hold', 'FSA Cancelled', 'Contract Active', 'Contract Hold', 'Contract Cancelled', 'Warranty', 'Complete',])} showFilterMenu={false}></Column>

          <Column field="project_name" header="Project Name" frozen style={{ minWidth: '14rem', position: 'sticky', backgroundColor: '#F8F9FA' }}
            body={(rowData) => (
              <span onClick={() => handleSelectionChange(rowData)}>
                {rowData.project_name}
              </span>
            )}></Column>

          <Column field="ProjectType" header="Project Type"
            body={(rowData) => (
              <span onClick={() => handleSelectionChange(rowData)}>
                {getProjectTypeNameAndIcon(rowData.project_type.name, rowData.project_type.color_code)}
              </span>
            )}

            frozen style={{ minWidth: '15rem', position: 'sticky', backgroundColor: '#F8F9FA' }}></Column>

          <Column field="internal_job" header="Internal Job" frozen body={(e) => e.internal_job === 'Y' ? '✅' : ''} style={{ width: '100px', position: 'sticky', textAlign: "center", backgroundColor: '#F8F9FA', borderRight: "2px solid gray" }} ></Column>

          <Column field="esitmatedSales" header="Estimated Sales" style={{ minWidth: '13rem', textAlign: "center", }} body={(e) => priceBodyTemplate(e.esitmatedSales)}></Column>

          <Column field="contact_date" header="Contact Date" body={(e) => showDate(e.contact_date)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="contact_to_fsa_month_by_day" header="Contact to FSA Months/Days" body={(e) => showDevide(e.contact_to_fsa_month_by_day)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="fsa_signed_date_em_playbook" header="FSA Signed Date" body={(e) => showDate(e.fsa_signed_date_em_playbook)} style={{ minWidth: '10rem', textAlign: "center", }} ></Column>

          <Column field="forecasted_building_date_em_playbook" header="Planned Building Permit Date" body={(e) => showDate(e.forecasted_building_date_em_playbook)} style={{ minWidth: '14rem', textAlign: "center", }}></Column>

          <Column field="building_permit_recieved_em_playbook" header="Building Permit Date" body={(e) => showDate(e.building_permit_recieved_em_playbook)} style={{ minWidth: '10rem', textAlign: "center", }} ></Column>

          <Column field="actual_pre_con_month_by_day_em_playbook" header="Actual Pre Con Months/Days" body={(e) => showDevide(e.actual_pre_con_month_by_day_em_playbook)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="of_pre_con_month_by_day_em_playbook" header="# Pre Con Months/Days Slippages" body={(e) => showDevide(e.of_pre_con_month_by_day_em_playbook)} style={{ minWidth: '14rem', textAlign: "center", }}></Column>

          <Column field="actual_pre_con_month_em_playbook" header="Actual # Pre Con Months" style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="contract_date" header="Contract Date" body={(e) => showDate(e.contract_date)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="fsa_to_contract_month_by_day" header="Fsa To Contract Month/Day" body={(e) => showDevide(e.fsa_to_contract_month_by_day)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="fsa_to_construction_start_month_by_day" header="Fsa To Construction Start Month/Day" body={(e) => showDevide(e.fsa_to_construction_start_month_by_day)} style={{ minWidth: '13rem', textAlign: "center", }}></Column>

          <Column field="actual_start_date_pm" header="Actual Start Date" body={(e) => showDate(e.actual_start_date_pm)} style={{ minWidth: '10rem', textAlign: "center", }} ></Column>

          <Column field="forecasted_complation_data_pm" header="Planned Completion Date" body={(e) => showDate(e.forecasted_complation_data_pm)} style={{ minWidth: '14rem', textAlign: "center", }}></Column>

          <Column field="actual_complation_date_pm" header="Actual Completion Date" body={(e) => showDate(e.actual_complation_date_pm)} style={{ minWidth: '10rem', textAlign: "center", }} ></Column>

          <Column field="actual_slippage_of_month_dat_pm" header="Actual # of Months/Days" body={(e) => showDevide(e.actual_slippage_of_month_dat_pm)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="slippage_of_month_by_day_pm" header="# of Months/Days Slippages +/-" body={(e) => showDevide(e.slippage_of_month_by_day_pm)} style={{ minWidth: '14rem', textAlign: "center", }}></Column>

          <Column field="forecasted_month_pm" header="Forecasted # of Months" style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="actual_month_pm" header="Actual # of Months" style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="hours_per_day" header="Hours Per Day" style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="pM" header="Project Manager" body={(e) => getPMNameAndIcon(e.project_manager.first_name + ' ' + e.project_manager.last_name, e.project_manager.color_code)} style={{ minWidth: '12rem', textAlign: "center", }}></Column>

          <Column field="actual_start_date_pm" header="Start Date" body={(e) => showDate(e.actual_start_date_pm)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="actual_complation_date_pm" header="Completion Date" body={(e) => showDate(e.actual_complation_date_pm)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="monthLeft" header="Months Left" style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="orig_expected_gp" header="Original Expected GP " body={(e) => priceBodyTemplate(e.orig_expected_gp)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="orig_gp_month" header="Original GP Months" body={(e) => priceBodyTemplate(e.orig_gp_month)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="newExpectedGP" header="New Expected GP" body={(e) => priceBodyTemplate(e.newExpectedGP)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="updatedGPMonth" header="Updated GP/Month" body={(e) => priceBodyTemplate(e.updatedGPMonth)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="gpTermofProjectperMonth" header="GP -/+ Term of Project/Month" body={(e) => priceBodyTemplate(e.gpTermofProjectperMonth)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="gpTermofProject" header="GP -/+ Term of Project" body={(e) => priceBodyTemplate(e.gpTermofProject)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="perofGPSlippage" header="% of GP Slippage" body={(e) => priceBodyTemplatee(e.perofGPSlippage)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="contract_amount" header="Contract Amoount" body={(e) => priceBodyTemplate(e.contract_amount)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="project_cost_per" header="PROJECTED COST - FEES" body={(e) => priceBodyTemplateForProjectedCosetFees(e.project_cost_per, e.contract_amount)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="actual_to_date" header="ACTUALS TO DATE" body={(e) => priceBodyTemplate(e.actual_to_date)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="actual_fees" header="ACTUALS - FEES" body={(e) => priceBodyTemplate(e.actual_fees)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="margin" header="MARGIN %" body={(e) => priceBodyTemplatee(e.margin)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="feesTotal" header="FEES TOTAL" body={(e) => priceBodyTemplate(e.feesTotal)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="feesToDate" header="FEES TO DATE" body={(e) => priceBodyTemplate(e.feesToDate)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="feesLeft" header="FEES LEFT" body={(e) => priceBodyTemplate(e.feesLeft)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="fessPerMonth" header="FEES P/M" body={(e) => priceBodyTemplate(e.fessPerMonth)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="directCostRemaining" header="DIRECT COST REMAINING" body={(e) => priceBodyTemplate(e.directCostRemaining)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="directcostperMonth" header="DIRECT COST P/M" body={(e) => priceBodyTemplate(e.directcostperMonth)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="complete" header="% COMPLETE" body={(e) => priceBodyTemplatee(e.complete)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="overUnderBilling" header="OVER UNDER BILLING" body={(e) => priceBodyTemplate(e.overUnderBilling)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="revenueEarnedToDate" header="REVENUE EARNED TO DATE" body={(e) => priceBodyTemplate(e.revenueEarnedToDate)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>

          <Column field="overallPersanatage" header="Over All %" body={(e) => priceBodyTemplatee(e.overallPersanatage)} style={{ minWidth: '10rem', textAlign: "center", }}></Column>


        </DataTable>
      </div>
    </div>)
  }


  return (
    <>
      {/* //? --------------------------------------- */}
      <div className="" >
        <Toast ref={toast} />
        <div className="" >
          <div className="gap-2 mb-3 " >
            {isLoading ? (
              <div className="loading-spinner">
                Loading...
                <div className="spinner"></div>
              </div>
            ) : (
            
              DataTableTabView('#0A6847')

            )}
          </div>

        </div>

        {/* //* ----------------Add Modals Start------------------------- */}
        <Dialog header="" visible={isAddManualModalOpen} maximizable style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsAddManualModalOpen(false)}>
          <div className='card'>
            <form onSubmit={formik.handleSubmit} className="" >
              <div className=" formgrid grid">
                <div className="col-6 ">
                  <label >ACTUAL START DATE</label>
                  <input
                    type="date"
                    style={{ height: '40px' }}
                    name="actualStartDatePM"
                    value={formik.values.actualStartDatePM}
                    onChange={(e) => formik.setFieldValue('actualStartDatePM', e.target.value)}
                  />
                </div>

                <div className="col-6 ">
                  <label >FORECASTED COMPLETION DATE</label>
                  <input
                    type="date"
                    style={{ height: '40px' }}
                    name="forecastedCompletionDatePM"
                    value={formik.values.forecastedCompletionDatePM}
                    onChange={(e) => formik.setFieldValue('forecastedCompletionDatePM', e.target.value)}
                  />
                </div>

                <div className="col-6 mt-5">
                  <label >ACTUAL COMPLETION DATE</label>
                  <input
                    type="date"
                    style={{ height: '40px' }}
                    name="actualCompletionDatePM"
                    value={formik.values.actualCompletionDatePM}
                    onChange={(e) => formik.setFieldValue('actualCompletionDatePM', e.target.value)}
                  />
                </div>

              </div>
              <div className="card flex flex-wrap justify-content-center gap-3">
                <Button label="Submit" title="save the Project" type="submit" className='p-2' />
              </div>
            </form>

          </div>
        </Dialog>
        {/* //! ----------------Add Modals End------------------------- */}



        {isModalOpen && (
          <form className="modal" onSubmit={handleAddProject} >
            <div className="modal-content">
              <div className="modal-header sticky-header">
                <button className="modal-close" onClick={closeModal}>
                  &times;
                </button>
                <h5 className="modal-title">{projectTitle}</h5>
                
                <div>
                  <button type="button" title='Save the Date' style={{ cursor: 'pointer' }} className="copySave-button m-2" onClick={closeModal}>
                    <div className='flex items-center gap-2 px-1 py-1 ' style={{ alignItems: 'center' }}>
                      <span> CANCEL </span>
                    </div>
                  </button>
                </div>
                
                <div>
                  <button type="submit" title='Save the Date' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                    <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
                      <BiCheck size={22} />
                      <span> SAVE </span>
                    </div>
                  </button>
                </div>
              </div>

              <div className="modal-body" style={{ marginTop: '30px' }}>

                {/* //*------------------------------- */}
                <div className="flex flex-wrap">
                  <div className="form-column">
                    <label htmlFor="newProjectName">
                      <h4>Project Name: </h4>
                    </label>
                    <InputText
                      type="text"
                      name="projectName"
                      className="input-field"
                      value={projectName}
                      placeholder="Enter project name"
                      required
                      onChange={(e) => setProjectName(e.target.value)}
                    />
                  </div>

                  <div className="form-column">
                    <label htmlFor="projectTypeLabelq">
                      <h4> Project Type:</h4>
                    </label>
                    <select className="input-field" id="projectType" required name="projectType"
                      value={projectTypeName} style={{ backgroundColor: '#' + backgroundColorForProjectType, fontWeight: '500' }}
                      onChange={(e) => onProjectTypeOnChange(e)}>
                      {projectsType.map((row) => (
                        <option key={row.id} value={row.id} style={{ backgroundColor: '#' + row.color_code, margin: "10px" }}>{row.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-column" >
                    <label htmlFor="internal_job" >
                      <h4>Internal Job</h4>
                    </label>
                    <Checkbox
                      className="m-2"
                      name="internal_job"
                      style={{ width: '90%' }}
                      value={internalJob}
                      checked={internalJob == 'Y' ? true : false}
                      onChange={(e) => {
                        console.log(e.value)
                        setInternalJob(e.checked ? 'Y' : 'N');
                      }}
                    />
                  </div>

                  <div className="form-column">
                    <label htmlFor="contract_amount">
                      <h4>Contract Amount</h4>
                    </label>
                    <InputNumber
                      inputId={contract_amount < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="contract_amount"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      mode="currency"
                      currency="USD"
                      locale="en-US"
                      value={contract_amount}
                      onChange={(e) => {
                        setContract_amount(e.value)
                        setProjectEsitmatedSales(e.value)
                      }}
                    />
                  </div>

                  <div className="form-column">
                    <label htmlFor="hoursPerDaylabel">
                      <h4>Hours Per Day</h4>
                    </label>
                    <InputNumber
                      id="hoursPerDay"
                      value={hoursPerDay}
                      name="hoursPerDay"
                     
                      className="InputNumber"
                      style={{ width: '90%' }}
                      // onChange={(e) => setHoursPerDay(e.target.value)}
                      onValueChange={(e) => setHoursPerDay(e.value)} 
                      placeholder="Hours Per Day"
                    />
                  </div>

                  <div className="form-column">
                    <label htmlFor="projectStatuslabel">
                      <h4>Project Status :</h4>
                    </label>
                    <select className="input-field"
                      id="projectStatus"
                      required
                      name="projectStatus"
                      value={projectStatus}
                      style={{ backgroundColor: inputBackgroundColor, color: 'white' }}
                      onChange={(e) => setProjectStatus(e.target.value)}>

                      <option value="Opportunity"  style={{ backgroundColor: '#00AC47' }}>Opportunity</option>
                      <option value="Lead" style={{ backgroundColor: '#0b2ca1' }}>Lead</option>
                      <option value="Lead Lost" style={{ backgroundColor: '#fc1b5f' }}>Lead Lost</option>
                      <option value="Lead Hold" style={{ backgroundColor: '#740001' }}>Lead Hold</option>
                      <option value="'Lead Tuned Down" style={{ backgroundColor: '#bc0571' }}>'Lead Tuned Down</option>
                      <option value="FSA Active" style={{ backgroundColor: '#8728e2' }}>FSA Active</option>
                      <option value="FSA Hold" style={{ backgroundColor: '#ef24bb' }}>FSA Hold</option>
                      <option value="FSA Cancelled" style={{ backgroundColor: '#59260b' }}>FSA Cancelled</option>
                      <option value="Contract Active" style={{ backgroundColor: '#0a673d' }}>Contract Active</option>
                      <option value="Contract Hold" style={{ backgroundColor: '#ef24bb' }}>Contract Hold</option>
                      <option value="Contract Cancelled" style={{ backgroundColor: '#bc0571' }}>Contract Cancelled</option>
                      <option value="Warranty" style={{ backgroundColor: '#fbac66' }}>Warranty</option>
                      <option value="Complete" style={{ backgroundColor: '#74c365' }}>Complete</option>
                    </select>
                  </div>



                  <div className="form-column">
                    <label htmlFor="editedProjectName">
                      <h4>Original Expected GP</h4>
                    </label>
                    <InputNumber
                      inputId={projectOrigExpectedGP < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="orig_expected_gp"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      mode="currency"
                      currency="USD"
                      locale="en-US"
                      value={projectOrigExpectedGP}
                      // onChange={(e) => setProjectOrigExpectedGP(e.value)}
                      onValueChange={(e) => setProjectOrigExpectedGP(e.value)} 
                    />
                  </div>



                  <div className="form-column" >
                    <label htmlFor="projectActualToDate">
                      <h4>Actual To Date</h4>
                    </label>
                    <InputNumber
                      inputId={projectActualToDate < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="actual_to_date"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      mode="currency"
                      currency="USD"
                      locale="en-US"
                      value={projectActualToDate}
                      onChange={(e) => setProjectActualToDate(e.value)}
                    />
                  </div>

                  <div className="form-column" >
                    <label htmlFor="editedProjectName">
                      <h4>PROJECTED COST - FEES % (MARGIN %)</h4>
                    </label>
                    <InputNumber
                      inputId={projectCostPerForProject < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="project_cost_per"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      value={projectCostPerForProject}
                      onChange={(e) => setProjectCostPerForProject(e.value)}
                    />
                  </div>

                  <div className="form-column">
                    <label htmlFor="editedProjectName">
                      <h4>Actuals Minus Fees</h4>
                    </label>
                    <InputNumber
                      inputId={projectActualFees < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="actual_fees"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      mode="currency"
                      currency="USD"
                      locale="en-US"
                      value={projectActualFees}
                      onChange={(e) => setProjectActualFees(e.value)}
                    />
                  </div>



                  <div className="form-column" >
                    <div className="flex gap-x-10 text-gray-700">
                      <div className="mr-2">
                        <label htmlFor="editedProjectName">
                          <h4>Fixed Price</h4>
                        </label>
                      </div>
                      <div>
                        <BsFillInfoCircleFill className="text-sm" title="Fixed Price" />
                      </div>
                    </div>
                    <InputNumber
                      inputId={projectFixedPrice < 0 ? 'number-negataive-price' : 'positiveNumber'}
                      name="fixed_price"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      mode="currency"
                      currency="USD"
                      locale="en-US"
                      value={projectFixedPrice}
                      onChange={(e) => setProjectFixedPrice(e.value)}
                    />
                  </div>

                  <div className="form-column">
                    <div className="flex gap-x-10 text-gray-700">
                      <div className="mr-2">
                        <label htmlFor="editedProjectName">
                          <h4>Fixed Months</h4>
                        </label>
                      </div>
                      <div>
                        <BsFillInfoCircleFill className="text-sm" title="Fixed Months" />
                      </div>
                    </div>
                    <InputNumber  
                      name="fixed_month"
                      className="InputNumber"
                      style={{ width: '90%' }}
                      value={projectFixedMonth}
                      onValueChange={(e) => setProjectFixedMonth(e.value)}
                    
                    />
                  </div>

                </div>

                {/* //!------------------------------- */}


                {/* //*---------------new added Start----------- */}
                <div className="flex flex-wrap" style={{ borderTop: "2px solid black", }}>

                  <div className="form-column mt-4">
                    <label htmlFor="development_manager">
                      <h4>Development Manager</h4>
                    </label>
                    <select className="input-field" id="development_manager" required name="development_manager"
                      value={developmentManager}
                      onChange={(e) => setDevelopmentManager(e.target.value)}>
                      {developmentManagerList.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-column mt-4">
                    <label htmlFor="pre_con_manager">
                      <h4>Pre con Manager</h4>
                    </label>
                    <select className="input-field" id="pre_con_manager" required name="pre_con_manager"
                      value={preConManager}
                      onChange={(e) => setPreConManager(e.target.value)}>
                      {preConManagerList.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-column">
                    <label htmlFor="pMlabel">
                      <h4>Project Manager</h4>
                    </label>
                    <select className="input-field" id="pM" required name="pM"
                      value={pM}
                      onChange={(e) => setPM(e.target.value)}>
                      {projectsManager.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-column">
                    <label htmlFor="interior_design">
                      <h4>Interior Design</h4>
                    </label>
                    <select className="input-field" id="interior_design" required name="interior_design"
                      value={interiorDesign}
                      onChange={(e) => setInteriorDesign(e.target.value)}>
                      {interiorDesignList.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>


                  <div className="form-column">
                    <label htmlFor="job_autospy">
                      <h4>Job Autospy</h4>
                    </label>
                    <select className="input-field" id="job_autospy" required name="job_autospy"
                      value={pM}
                      disabled
                      onChange={(e) => setJobAutospy(e.target.value)}>
                      {jobAutospyList.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-column">
                    <label htmlFor="warranty">
                      <h4>Warranty</h4>
                    </label>
                    <select className="input-field" id="warranty" required name="warranty"
                      value={pM}
                      disabled
                      onChange={(e) => setWarranty(e.target.value)}>
                      {warrantyList.map((row) => (
                        <option value={row.user_id} selected={row.first_name + ' ' + row.last_name === pM}>{row.first_name + ' ' + row.last_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* //*---------------new added End----------- */}


              </div>
            </div>
          </form>
        )}

        {/* //* ------------------------Delete-Modals Start---------------------- */}

        {isDeleteConfirmationModalOpen && (
          <div className="modal">
            <div className="small-modal-content">
              <div className="modal-headerx">
                <h5 className="modal-title">Delete Confirmation</h5>
                <button className="modal-closex" onClick={closeModal}>
                  &times;
                </button>
              </div>
              <div className="modal-bodyx">
                <p>{projectDeletetitle}</p>
              </div>
              <div className="modal-footer-cancelx">
                <button title="Cancel the Project" className="cancel-buttonx" onClick={closeModal}>
                  Cancel
                </button>
                <button title="Delete the Project" className="delete-buttonx" onClick={confirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {/* //!------------------------Delete-Modals End--------------------- */}

      </div>
    </>
  );
};

export default Project;
